import {useMutation, useQuery} from "@tanstack/react-query"

import api, {queryKey} from "../services"

export function useVerifySaaSCompanyMutation() {
  return useMutation({
    mutationFn: (data: Parameters<typeof api.invitationAcceptances.invitationAcceptancesCreate>[0]) =>
      api.invitationAcceptances.invitationAcceptancesCreate(data),
  })
}

export function useRegisterSaaSCompanyManagingMutation() {
  return useMutation({
    mutationFn: (data: Parameters<typeof api.saasCompanyUsers.saasCompanyUsersCreate>[0]) =>
      api.saasCompanyUsers.saasCompanyUsersCreate(data),
  })
}

export function useResendSaaSCompanyConfirmationMutation() {
  return useMutation({
    mutationFn: ({email}: {email: string}) => api.saasCompanyUsers.confirmationCreate({saas_company_user: {email}}),
  })
}

export function useSaaSCompanyOnboardingStatusQuery({enabled = true}: {enabled?: boolean} = {}) {
  return useQuery({
    queryKey: queryKey.saasCompanyOnboardingStatus(),
    queryFn: async () => (await api.saasCompanyUsers.onboardingStatusList()).data,
    enabled,
  })
}
